import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { postTraceability } from './api';
import { useHistory } from 'react-router';
import { EDIT_MODE } from '@src/constants';
import { ActivityTraceabilityDTO } from './dto/ActivityTraceabilityDTO';

type Props = {
  mode: string;
  activityId?: number;
};

function usePostTraceabilityData({ mode, activityId }: Props) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const history = useHistory();

  const { mutate, isLoading } = useMutation(
    (activityTraceability: ActivityTraceabilityDTO) => postTraceability(activityTraceability),
    {
      onSuccess: () => {
        if (mode != EDIT_MODE) {
          if (activityId) {
            history.push(`/activity/view/${activityId}`);
          }
        }
        queryClient.invalidateQueries('activityTraceability');
        toast.success(t('message.title.success.post.traceability'));
      },
      onError: error => {
        toast.error(t('message.title.error.post.traceability'));
      },
    }
  );
  return { postTraceability: mutate, isLoadingTraceability: isLoading };
}

export default usePostTraceabilityData;
